'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Circlechecked;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Circlechecked(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 24 24',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M12,1 C18.0722847,1 23,5.92771525 23,12 C23,18.0722847 18.0722847,23 12,23 C5.92771525,23 1,18.0722847 1,12 C1,5.92771525 5.92771525,1 12,1 Z',
    stroke: '#FFFFFF',
    strokeWidth: '2'
  }), _react2.default.createElement('polygon', {
    id: 'Path',
    fill: '#FFFFFF',
    fillRule: 'nonzero',
    points: '10 17 5 12 6.41 10.59 10 14.17 17.59 6.58 19 8'
  }));
}
Circlechecked.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};